/**
 * BackUp模块接口列表
 */
 import $http from '../utils/http'; // 导入http中创建的axios实例

 const resourceAwsBackupPlan = {
   //分页
   pageBackUp(params) {
     return $http.post(`${global.API_URL}/sme/resourceAwsBackupPlan/page`,params);
   },
   //查询当前用户下所有Redshift
   queryRedshiftByAccount(params) {
     return $http.post(`${global.API_URL}/sme/redshift/queryRedshiftByAccount`,params);
   },
   //查询备份计划列表
   queryBackupPlans(params) {
    return $http.post(`${global.API_URL}/sme/resourceAwsBackupPlan/queryBackupPlans`,params);
  },
   //详情
   queryBackupPlanByBackupPlanId(params) {
     return $http.post(`${global.API_URL}/sme/resourceAwsBackupPlan/queryBackupPlanByBackupPlanId`,params);
   },
   //删除
   deleteBackUpPlan(id ,params) {
     let param = new URLSearchParams();
     param.append(id, params);
     return $http.post(`${global.API_URL}/sme/resourceAwsBackupPlan/delete`,param);
   }
 }
 
 export default resourceAwsBackupPlan;
 


// WEBPACK FOOTER //
// ./src/api/resourceAwsBackupPlan.js